import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  onToggle?: () => void;
}
export function AccordionItem({
  title,
  children,
  isOpen,
  onToggle
}: AccordionItemProps) {
  return <div className="border-b border-[#2c4a2c]/10 last:border-0" data-id="element-325">
      <button onClick={onToggle} className="flex w-full items-center justify-between py-4 text-left font-medium text-[#2c4a2c] transition-all hover:text-[#c45d3a]" data-id="element-326">
        <span className="text-lg" data-id="element-327">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-328">
          <ChevronDown className="h-5 w-5 opacity-50" data-id="element-329" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-330">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-331">
            <div className="pb-4 text-[#5a5a5a] leading-relaxed" data-id="element-332">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
  allowMultiple?: boolean;
}
export function Accordion({
  items,
  allowMultiple = false
}: AccordionProps) {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const handleToggle = (index: number) => {
    if (allowMultiple) {
      setOpenIndexes(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
    } else {
      setOpenIndexes(prev => prev.includes(index) ? [] : [index]);
    }
  };
  return <div className="w-full rounded-2xl bg-white p-6 shadow-sm ring-1 ring-[#2c4a2c]/5" data-id="element-333">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndexes.includes(index)} onToggle={() => handleToggle(index)} data-id="element-334">
          {item.content}
        </AccordionItem>)}
    </div>;
}